import * as yup from 'yup';

export const formSchema = yup.object().shape({
  date: yup.mixed().required('日付は未入力です。'),
  category: yup.string().required('種類は未選択です。'),
  title: yup
    .string()
    .trim()
    .required('タイトルは未入力です。')
    .max(100, 'タイトルは100文字以内で入力してください。'),
  description: yup
    .string()
    .nullable()
    .max(2000, '概要は2000文字以内で入力してください。'),
});
